module.exports = __webpack_public_path__ + "static/media/Bride.2aa59756.jpg";